import React from 'react';
import '../footer/Footer.css';

const Footer = () => {
    return (
        <div className='footer'>
            <footer className='footer-container'>
                <div className='footer-container-header'>
                    <div className='footer-container-header-bloc'>
                        <div className='footer-container-header-bloc-item'>
                            <h5> © 2025 Copyright: IvoirePresse</h5>
                        </div>
                    </div>
                   
                </div>
            </footer>
        </div>
    );
};

export default Footer;